import {
  IDataTemplateSettings,
  IGptPhrases,
} from "src/modules/idom-mem/models";

export interface IdomMemStateInterface {
  settings: IDataTemplateSettings | undefined;
  counts: Record<string, number>;
  loading: boolean;
  gptPhrases: IGptPhrases[];
  loadingGpt: boolean;
}

function state(): IdomMemStateInterface {
  return {
    gptPhrases: [],
    settings: undefined,
    counts: {},
    loading: false,
    loadingGpt: false,
  };
}

export default state;
